<template>
  <div class="page_main">
    <div class="search_block">
      <Form :label-width="85" inline>
        <!-- <FormItem label="就诊类别">
          <Select v-model="table.search.PatientType" clearable>
            <Option v-for="item in PatientTypeList" :value="item" :key="item">{{ item }}</Option>
          </Select>
        </FormItem> -->
        <FormItem label="检查类型">
          <Select v-model="table.search.ExamTypeName" clearable>
            <Option
              v-for="item in ExamTypeNameList"
              :value="item"
              :key="item"
              >{{ item }}</Option
            >
          </Select>
        </FormItem>
        <FormItem>
          <Select
            placeholder="请选择"
            v-model="table.search.dateType"
            class="w-250"
            clearable
          >
            <Option :value="1000" :key="index">检查日期 </Option>
            <Option :value="1001" :key="index">登记日期 </Option>
          </Select>
        </FormItem>
        <FormItem label="时间" :label-width="60">
          <Date-picker
            v-model="timeValue"
            :options="dateOptions"
            style="width: 200px"
            format="yyyy-MM-dd"
            type="daterange"
            placement="bottom-end"
            placeholder="请选择时间"
            :clearable="false"
            @on-change="
              (val) => {
                table.search.BeginTime = val[0];
                table.search.EndTime = val[1];
              }
            "
          ></Date-picker>
        </FormItem>
      </Form>
      <div>
        <Button class="mr-3" @click="resetHandle">重置</Button>
        <Button class="mr-3" type="success" @click="search">查询</Button>
      </div>
    </div>
    <div class="fx-row">
      <div class="block-lf fx-col">
        <Input
          v-model="organName"
          class="lf-search"
          placeholder="请输入医院名称"
          clearable
          @on-enter="getHospital"
        ></Input>
        <div class="hos-list fx-1">
          <!-- <Tooltip :content="item.organName" v-for="item in hospitalList" :key="item.organID"> -->
          <div
            v-for="item in hospitalList"
            :key="item.organID"
            :class="{ 'hos-active': item.status == 1 }"
            class="hos-list-item"
            @click="selHosItem(item)"
          >
            <div>{{ item.organName }}</div>
            <Icon v-show="item.status == 1" type="md-checkmark" />
            <i v-show="item.status != 1" class="icon-place"></i>
          </div>
          <!-- </Tooltip> -->
        </div>
      </div>
      <div class="block-rig fx-1">
        <div class="fx-cen">
          <div class="w100"></div>
          <div class="tc fx-1">
            <p class="rig-title">
              <span>{{
                table.search.BeginTime
                  ? table.search.BeginTime + "至" + table.search.EndTime
                  : ""
              }}</span>
              检查量统计 <span></span>{{ examineCount }}(人次)
            </p>
            <p class="rig-title-sm">
              【统计条件】检查时间：{{
                table.search.BeginTime
                  ? table.search.BeginTime + "至" + table.search.EndTime
                  : "全部"
              }}，机构名称：{{
                organNameList.length == 0 ? "无" : organNameList.toString()
              }}，检查类型：{{
                table.search.ExamTypeName ? table.search.ExamTypeName : "全部"
              }}
            </p>
            <!-- ，就诊类别：{{table.search.ExamTypeName?table.search.ExamTypeName:'全部'}} -->
          </div>
          <div class="tr w100">
            <Button class="mr-3" @click="exportHandle">导出</Button>
          </div>
        </div>
        <div class="fx-row">
          <!-- <div class="fx-1 table-mar tr"> -->
          <DataTable
            class="table-width"
            ref="dataTable"
            tableDataName="obj"
            :pageShow="false"
            :columns="table.columns"
            :apiUrl="table.apiUrl"
            :search="table.search"
            requestType="post"
            @getData="getTableData"
          ></DataTable>
          <!-- <Table :height="500" :columns="columns" :data="tableData" border disabled-hover highlight-row stripe></Table>
            <Page 
              class="mt-16"
              :total="pagination.total"
              :page-size-opts="pagination.sizes"
              :current="pagination.search.PageIndex"
              :page-size="pagination.search.PageSize"
              show-elevator
              show-sizer
              show-total
              @on-change="pageChange"
              @on-page-size-change="sizeChange">
            </Page> -->
          <!-- </div> -->
          <div class="rig-chart mr-3">
            <div ref="myEchart" class="mb-16"></div>
            <div ref="myEchart2"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DataTable from "@/components/DataTable.vue";
import echarts from "echarts";
import dayjs from "dayjs";
export default {
  components: {
    DataTable,
  },
  data() {
    const toDay = dayjs().format("YYYY-MM-DD");
    return {
      activeIndex: [],
      checkTypeList: [],
      typeList: [],
      myChart: null,
      myChart2: null,
      organName: "",
      table: {
        columns: [
          {
            title: "序号",
            type: "index",
            align: "center",
            width: "60",
          },
          {
            title: "医院名称",
            align: "center",
            key: "name",
          },
          {
            title: "检查总量",
            align: "center",
            key: "count",
          },
          {
            title: "检查类型",
            align: "center",
            render: (h, params) => {
              return h(
                "div",
                {
                  attrs: {
                    class: "subCol",
                  },
                },
                [
                  h(
                    "ul",
                    params.row.orderInfo.map((item) => {
                      return h("li", {}, item.examTypeName);
                    })
                  ),
                ]
              );
            },
          },
          // {
          //   title: '检查类型',
          //   align: 'center',
          //   key: 'list',
          // },
          {
            title: "检查量",
            align: "center",
            render: (h, params) => {
              return h(
                "div",
                {
                  attrs: {
                    class: "subCol",
                  },
                },
                [
                  h(
                    "ul",
                    params.row.orderInfo.map((item) => {
                      return h("li", {}, item.count);
                    })
                  ),
                ]
              );
            },
          },
        ],
        apiUrl: "HomePage/GetDataStatistics",
        search: {
          ExamOrganCode: [],
          ExamTypeName: "",
          dateType: 1000,
          BeginTime: toDay,
          EndTime: toDay,
        },
      },
      hospitalList: [],
      tableData: [],
      // PatientTypeList: [],
      ExamTypeNameList: [],
      organNameList: [],
      examineCount: 0,
      echartTypeList: [],
      echartValList: [],
      timeValue: [toDay, toDay],
      dateOptions: {
        shortcuts: [
          {
            text: "最近三天",
            value() {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 2);
              return [start, end];
            },
          },
          {
            text: "最近一周",
            value() {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
              return [start, end];
            },
          },
          {
            text: "最近一个月",
            value() {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              return [start, end];
            },
          },
          {
            text: "最近三个月",
            value() {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              return [start, end];
            },
          },
        ],
      },
    };
  },
  mounted() {
    // this.initEcharts2()
    this.getHospital();
    // this.getPatientTypeList()
  },
  created() {
    this.getExamTypeNameList();
  },
  // activated(){
  //   this.search()
  // },
  methods: {
    search: function () {
      function removeEmptyValues(obj) {
        for (const key in obj) {
          if (typeof obj[key] === "object") {
            removeEmptyValues(obj[key]);
          }

          if (
            !obj[key] ||
            (typeof obj[key] === "object" && !Reflect.ownKeys(obj[key]).length)
          ) {
            delete obj[key];
          }
        }
      }
      removeEmptyValues(this.table.search);
      const list = this.hospitalList.filter((item) => item.status == 1);
      this.table.search.ExamOrganCode = list.map((item) => item.organCode);
      if (this.table.search.ExamOrganCode.length == 0) {
        this.$Message.warning("请选择医院！");
        return;
      }
      this.organNameList = list.map((item) => item.organName);
      this.$refs.dataTable.initload();
    },
    getTableData(val) {
      if (val) {
        this.examineCount = val.obj.reduce(
          (prev, next) => prev + next.count,
          0
        );
        // if(val.obj.length!=0){
        //   this.echartTypeList=val.obj[0].orderInfo.map(item=>item.ExamTypeName)
        //   let list=this.echartTypeList.map(item=>{
        //     return {
        //       value: 0,
        //       name: item
        //     }
        //   })
        //   val.obj.forEach(item=>{
        //     this.echartTypeList.forEach((sonItem,sonIndex)=>{
        //       list[sonIndex].value=list[sonIndex].value+item.orderInfo[sonIndex].count
        //     })
        //   })
        //   this.echartValList=list
        //   this.initEcharts1()
        //   console.log(list)
        // }
        if (val.dictionary) {
          this.echartTypeList = Object.keys(val.dictionary);
          console.log(this.echartTypeList);
          this.echartValList = this.echartTypeList.map((item) => {
            return {
              name: item,
              value: val.dictionary[item],
            };
          });
        }
        this.initEcharts1();
      } else {
        this.examineCount = 0;
        this.echartTypeList = this.ExamTypeNameList;
        this.echartValList = this.ExamTypeNameList.map((item) => {
          return {
            name: item,
            value: 0,
          };
        });
        this.initEcharts1();
      }
    },
    getHospital() {
      this.$api
        .get("/HomePage/GetOrganinfoList", {
          organName: this.organName,
        })
        .then((rsp) => {
          console.log(rsp, "--------------");
          if (rsp != false) {
            this.hospitalList = rsp.data.map((item) => {
              return {
                ...item,
                status: 0,
              };
            });
            console.log(this.hospitalList);
          }
        });
    },
    // getPatientTypeList(){
    //   this.$api.get('/HomePage/GetPatientTypeList').then((rsp) => {
    //     if (rsp != false) {
    //       this.PatientTypeList=rsp.data
    //     }
    //   });
    // },
    getExamTypeNameList() {
      this.$api.get("/HomePage/GetExamTypeNameList").then((rsp) => {
        if (rsp != false) {
          this.ExamTypeNameList = rsp.data;
          this.echartTypeList = rsp.data;
          this.echartValList = rsp.data.map((item) => {
            return {
              name: item,
              value: 0,
            };
          });
          this.initEcharts1();
        }
      });
    },
    exportHandle() {
      const list = this.hospitalList.filter((item) => item.status == 1);
      this.table.search.ExamOrganCode = list.map((item) => item.organCode);
      let baseUrl = localStorage.getItem("baseURL");
      const Qs = require("qs");
      let params = Qs.stringify(this.table.search);
      let url = baseUrl + "/HomePage/InspectionQuantityExport?" + params;
      window.open(url);
    },
    initEcharts1() {
      this.myChart = echarts.init(this.$refs.myEchart);
      let option = {
        backgroundColor: "#F2F3F5",
        tooltip: {
          trigger: "item",
        },
        legend: {
          orient: "vertical",
          top: "32%",
          right: "10px",
          // itemGap: 50,
          itemWidth: 8,
          itemHeight: 8,
          textStyle: {
            color: "#333",
            fontSize: 10,
          },
          data: this.echartTypeList,
        },
        title: [
          {
            text: this.examineCount,
            subtext: "总检查量",
            textAlign: "center",
            x: "38%",
            y: "50%",
            textStyle: {
              fontSize: 27,
              fontWeight: "normal",
              color: "#333333",
            },
            subtextStyle: {
              fontSize: 12,
              fontWeight: "normal",
              align: "center",
              color: "#999",
            },
          },
          {
            text: "检查类型分布",
            x: "24px",
            y: "24px",
            textStyle: {
              fontSize: 18,
              fontWeight: "normal",
              color: "#333333",
            },
          },
        ],
        series: [
          {
            type: "pie",
            radius: ["70", "50"],
            center: ["40%", "60%"],
            label: {
              show: false,
            },
            labelLine: {
              show: false,
            },
            color: [
              "#8543E0",
              "#1890FF",
              "#36CBCB",
              "#2FC25B",
              "#FACC14",
              "#F04864",
            ],
            itemStyle: {
              normal: {
                borderWidth: 5,
                borderColor: "#F2F3F5",
              },
            },
            data: this.echartValList,
          },
        ],
      };
      this.myChart.setOption(option);
    },
    initEcharts2() {
      this.myChart2 = echarts.init(this.$refs.myEchart2);
      let option2 = {
        backgroundColor: "#F2F3F5",
        tooltip: {
          trigger: "item",
        },
        legend: {
          orient: "vertical",
          top: "32%",
          right: "10px",
          // itemGap: 50,
          itemWidth: 8,
          itemHeight: 8,
          textStyle: {
            color: "#333",
            fontSize: 10,
          },
          data: ["门诊", "住院", "卒中", "急诊", "体检", "创伤"],
        },
        title: [
          {
            text: "14000",
            subtext: "总检查量",
            textAlign: "center",
            x: "38%",
            y: "50%",
            textStyle: {
              fontSize: 27,
              fontWeight: "normal",
              color: "#333333",
            },
            subtextStyle: {
              fontSize: 12,
              fontWeight: "normal",
              align: "center",
              color: "#999",
            },
          },
          {
            text: "检查类型分布",
            x: "24px",
            y: "24px",
            textStyle: {
              fontSize: 18,
              fontWeight: "normal",
              color: "#333333",
            },
          },
        ],
        series: [
          {
            type: "pie",
            radius: ["70", "50"],
            center: ["40%", "60%"],
            label: {
              show: false,
            },
            labelLine: {
              show: false,
            },
            color: [
              "#8543E0",
              "#1890FF",
              "#36CBCB",
              "#2FC25B",
              "#FACC14",
              "#F04864",
            ],
            itemStyle: {
              normal: {
                borderWidth: 5,
                borderColor: "#F2F3F5",
              },
            },
            data: [
              {
                value: 27,
                name: "门诊",
              },
              {
                value: 30,
                name: "住院",
              },
              {
                value: 24,
                name: "卒中",
              },
              {
                value: 27,
                name: "急诊",
              },
              {
                value: 27,
                name: "体检",
              },
              {
                value: 27,
                name: "创伤",
              },
            ],
          },
        ],
      };
      this.myChart2.setOption(option2);
    },
    selHosItem(item) {
      item.status ? (item.status = 0) : (item.status = 1);
    },
    resetHandle() {
      const toDay = dayjs().format("YYYY-MM-DD");
      this.timeValue = [toDay, toDay];
      this.table.search.ExamTypeName = "";
      // this.table.search.PatientType=''
      this.table.search.BeginTime = toDay;
      this.table.search.EndTime = toDay;
    },
  },
};
</script>
<style scoped lang="less">
/deep/.ivu-picker-panel-sidebar {
  width: 105px;
  margin-left: -105px;
}

.table-width {
  width: calc(100vw - 725px);
}

.block-lf {
  width: 230px;
  background: #fff;
  padding: 12px;
  border-radius: 10px;
  height: calc(100vh - 3.5rem - 135px);

  .lf-search /deep/.ivu-input {
    background: #f2f3f5;
    border: none;
  }

  .hos-list {
    overflow-y: scroll;
    overflow-x: hidden;
    margin-top: 10px;
    font-size: 16px;

    .hos-list-item {
      color: #666666;
      padding: 5px;
      margin-bottom: 5px;
      cursor: pointer;
      width: 195px;
      display: flex;
      flex-direction: row;
      align-items: center;
      div {
        flex: 1;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .icon-place {
        width: 16px;
      }
    }

    .hos-active {
      background: rgba(45, 141, 240, 0.1);
      color: #2d8df0;
    }
  }
}

.block-rig {
  background: #fff;
  margin-left: 10px;
  border-radius: 10px;

  // padding-bottom: 16px;
  .rig-title {
    font-size: 20px;
    font-weight: 600;
    margin: 24px 0 6px;
    color: #000;

    span {
      color: #2d8df0;
    }
  }

  .rig-title-sm {
    font-size: 14px;
    margin-bottom: 9px;
  }

  .w100 {
    width: 100px;
  }

  .rig-chart {
    margin-top: 15px;
    width: 240px;

    > div {
      width: 240px;
      height: 240px;
    }
  }
}
</style>